<template>
<div class="page_toutiao page_dingzhi page_map optimize">
    <!-- 筛选 -->
    <div class="top_wrap">
        <div class="index_top">
            <div class="PageSearch page-search hasback">
                <van-row type="flex" justify="space-start">
                    <van-col v-if="searchlefticon" class="left_col">
                        <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                    </van-col>
                    <van-col :class="searchlefticon ? 'search_col': searchrighticon ? (isClient?'search_col_big_s':'search_col_big'): (isClient?'search_col_big_rise_s':'search_col_big_rise')" @click="toSearch">
                        <van-cell-group class="search_field">
                            <van-field v-model="search_value" :placeholder="activeType ? '请输入想要查找的内容' : '请输入要搜索的订制品'" disabled>
                                <van-icon slot="right-icon" :name="righticon" @click="search" />
                            </van-field>
                        </van-cell-group>
                    </van-col>
                    <van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
                        <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                    </van-col>
                    <van-col v-if="isClient" class="right_col" @click="clickShare">
                        <van-icon :name="searchShareicon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .5rem;" />
                    </van-col>
                </van-row>
            </div>
            <!-- 去定制 -->
            <div class="userdingzhi" @click="toDingzhiForm">
                <span class="">去定制</span>
                <van-icon name="arrow" />
            </div>
        </div>
        <!-- 当前页筛选 -->
        <div class="search" v-if="search_status">
            <!-- 选择分类 -->
            <div class="search_fenlei">
                <div class="search_title">选择分类</div>
                <ul class="search_list clearfix">
                    <li :class="item.active ? 'search_item f-l cate active': 'search_item f-l cate'" v-for="item in cateList" :key="item.id" :data-id="item.id" @click="clickCate(item)">{{item.title}}</li>
                </ul>
            </div>
            <!-- 重置 确定 -->
            <div class="search_actions">
                <div class="search_action" @click="reset">重置</div>
                <div class="search_action" @click="submit">确定</div>
            </div>
        </div>
    </div>
    <!-- 我要定制 发布定制 -->
    <div class="fenlei_wrap">
        <div :class="item.id == 1 ? 'icons user' : 'icons'" v-for="item in typeList" :key="item.id" @click="changeType(item)">
			<div class="text_wrap">
				<div class="name">{{ item.name }}</div>
				<div class="desc">{{ item.desc }}<span class="nums">{{ item.nums }}</span></div>
			</div>
        </div>
    </div>
    <!-- 推荐 -->
    <div class="tuijian" v-if="tuijianList.length != 0 && activeType != 1">
        <div class="title">热门推荐</div>
        <div class="list">
            <div class="item" v-for="(item,index) in tuijianList" :key="index" @click="goDetail(item)">
                <van-image fit="contain" :src="imageUrl+item.thumb" class="tu" :show-error="false" :show-loading="false" />
                <div class="nr">
                    <div class="title slh_s">{{ item.title }}</div>
                    <div class="tips">
                        <div class="tip">已定制</div>
                        <van-progress :percentage="item.percentage" :pivot-text="item.hadMadeCount+'件'"  color="linear-gradient(-90deg, #DF3434, #FF5F34)" />
						<div class="tip" v-if="item.end_at">{{ item.timeLeft ? '剩余时长：' : '截止日期：'}}<span class="nums">{{ item.timeLeft ? item.timeLeft :item.end_at }}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 分类 好去处、好手艺、好体验、好食材 -->
    <div class="where_wrap" v-if="activeType != 1">
        <div class="item" v-for="(item,index) in classifyList" :key="index" @click="clickclassify(item)">
            <img :src=" item.status ? (publicPath + item.icon_active) : (publicPath + item.icon_default)" alt="" class="icon">
            <div class="text">{{ item.title }}</div>
        </div>
    </div>
    <!-- 列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <!-- 匠人社区 -->
            <div class="list" v-if="activeType != 1">
                <div class="item" v-for="(item,index) in dataList" :key="index">
                    <div class="item_t">
                        <div class="item_t_l" @click="goArtDetail(item)">
                            <img v-if="item.tradesman" :src="item.tradesman.thumb ? ( $publicData.withHttpStart(item.tradesman.thumb) ? item.tradesman.thumb : imageUrl+item.tradesman.thumb) : $publicData.defaultTouxiang" alt="" class="tu">
                            <div class="text">
                                <div class="text_t">
                                    <div class="title slh_s" v-if="item.tradesman">{{item.tradesman.nickname}}</div>
                                </div>
                                <div class="text_t" v-if="item.tradesman && item.tradesman.data && item.tradesman.data.auth_company">
                                    <div class="tag slh_s">{{item.tradesman.data.auth_company}}</div>
                                </div>
                                <div class="time">{{item.created_at}}</div>
                            </div>
                        </div>
                        <div :class="item.is_attention ? 'guanzhu guanzhued' : 'guanzhu'" @click="attentionTadesmanClick(item)">{{item.is_attention ? '已关注' : '关注'}}</div>
                    </div>
                    <div class="item_spec" @click="goDetail(item)">
                        <div class="spec">类型: <span class="red" v-if="item.cate">{{item.cate.title}}</span></div>
                        <div class="spec">价格: <span class="red">{{item.price_range}}元</span>/个</div>
                    </div>
                    <div class="item_title slh" @click="goDetail(item)">{{item.descript}}</div>
                    <div class="lookall" @click="goDetail(item)">查看全文</div>
                    <div class="prism-player video_play" v-if="item.video_type==0&&item.other_video_url" :id="'play_'+item.id" :style="playStyle"></div>
                    <div class="prism-player video_play" v-else-if="item.video_type==1&&item.video_url" :id="'play_'+item.id" :style="playStyle"></div>
                    <div class="item_tu more" v-else>
                        <div class="tu_wrap" v-for="(image,index) in item.images_hide ? item.imagesSlice : item.images" :key="index" @click="zhanshitupian(item,item.images_hide ? item.imagesSlice : item.images,index)">
                            <van-image fit="contain" :src="imageUrl+image" class="tu" :show-error="false" :show-loading="false" />
                            <div class="mark" v-if="item.images_hide && index == 2">{{'+'+ (item.images.length -3)}}</div>
                        </div>
                    </div>
                    <!-- 分隔线 -->
                    <div class="line"></div>
                    <!-- 评论 收藏 点赞 -->
                    <div class="actions btns">
                        <div class="action comment" @click="goDetail(item)">
                            <div class="text">评论{{ '('+  item.comment_num + ')'}}</div>
                        </div>
                        <div :class="item.is_attentioncustomized ? 'action collect collected' : 'action collect'" @click="clickCollect(index,item)">
                            <div class="text">收藏{{ '('+  item.attention_num + ')'}}</div>
                        </div>
                        <div :class="item.is_click ? 'action like liked' : 'action like'" @click="clickLike(index,item)">
                            <div class="text">点赞{{ '('+  item.click_num + ')'}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 用户社区 -->
            <div class="list shequ" v-else>
                <div class="item" v-for="item in userDataList" :key="item.id">
                    <div class="item_t" @click="goDetail(item)">
                        <div class="item_t_l">
                            <img :src="item.thumb ? $publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb : $publicData.defaultTouxiang" alt="" class="tu">
                            <div class="text">
                                <div class="text_t column">
                                    <div class="title slh_s">{{item.username}}</div>
                                    <div class="tag">{{ item.cate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item_title slh" @click="goDetail(item)">{{ item.title }}</div>
                    <div class="item_tu more" @click="goDetail(item)">
                        <div class="tu_wrap" v-for="(image,index) in item.images_hide ? item.imagesSlice : item.images" :key="index">
                            <van-image fit="contain" :src="imageUrl+ image" class="tu" :show-error="false" :show-loading="false" />
                            <div class="mark" v-if="item.images_hide && index == 2">{{'+'+ (item.images.length -3)}}</div>
                        </div>
                    </div>
                    <div class="item_bottom" @click="goDetail(item)">
                        <div class="view">浏览{{'('+ item.look_num +')'}} </div>
                        <div class="time">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
    <!-- 发布按钮 匠人社区 -->
    <div class="post" @click="toDingzhiPublish" v-if="is_tradesman && activeType != 1">
        <img :src="publicPath+'statics/images/icon_fabu.png'" alt="" class="">
    </div>
    <!-- 发布按钮 用户社区 -->
    <div class="post" @click="toDingzhiPublish" v-if="activeType == 1">
        <img :src="publicPath+'statics/images/icon_fabu.png'" alt="" class="">
    </div>
    <!-- 遮罩层 -->
    <van-overlay :show="search_status" class="overlay" />
    <!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            searchlefticon: '', // 搜索栏左侧图标
            searchrighticon: process.env.BASE_URL + 'statics/images/icon_shaixuan_white.png', // 搜索栏右侧图标
            searchShareicon: process.env.BASE_URL + 'statics/images/dingzhi_share.png', // 分享
            search_value: '', // 搜索值
            readonly: true, // 搜索栏只读
            placeholder: '请输入要搜索的订制品',
            righticon: process.env.BASE_URL + '/statics/images/search_ico.png', // 搜索框搜索图标
            publicPath: process.env.BASE_URL,
            token: null,
            cateList: null, // 分类
            search_status: false, // 筛选层是否展开
            pages: {
                page: 1,
                size: 10
            },
            cate_id: null, // 分类id
            loading: false,
            finished: false,
            refreshing: false,
            dataList: [], // 匠人社区定制列表
            userDataList: [], // 用户社区定制列表
            bigTuShow: false,
            bigTuIndex: 0,
            bigTuImgArr: null,
            is_tradesman: null, // 匠人角色
            classifyList: [{
                    title: '好去处',
                    name: 'is_good_where',
                    icon_default: 'statics/images/dingzhi/icon_where_default.png',
                    icon_active: 'statics/images/dingzhi/icon_where_active.png',
                    status: false
                },
                {
                    title: '好手艺',
                    name: 'is_good_craft',
                    icon_default: 'statics/images/dingzhi/icon_skill_default.png',
                    icon_active: 'statics/images/dingzhi/icon_skill_active.png',
                    status: false
                },
                {
                    title: '好体验',
                    name: 'is_good_experience',
                    icon_default: 'statics/images/dingzhi/icon_tiyan_default.png',
                    icon_active: 'statics/images/dingzhi/icon_tiyan_active.png',
                    status: false
                },
                {
                    title: '好食材',
                    name: 'is_good_food',
                    icon_default: 'statics/images/dingzhi/icon_eat_default.png',
                    icon_active: 'statics/images/dingzhi/icon_eat_active.png',
                    status: false
                },
            ],
            tuijianList: [], // 推荐
            typeList: [{
                    id: 0,
					name: '匠人社区',
					desc: '本周上新',
					// nums: 12,
                    status: true // 默认为匠人社区
                },
                {
                    id: 1,
					name: '用户社区',
					desc: '本周新分享',
					// nums: 23,
                    status: false
                },
            ],
            activeType: 0, // 默认为匠人社区
            likeLoading: false,
            instances:[],
            player: null,
            playStyle: { //375*246 宽高比 1.52
                height: '6.4rem',
                display: 'none',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
                width:'auto'
            },
            goNext: false,
            isClient: false
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                'data': {
                    'naviTitle': '定制',
                    levitate: true,
                    showStatusBar: true,
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    // 获取用户角色信息
                    this.getUserInfo()
                } else {
                    this.token = ''
                }

            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取用户角色信息
            
        }
        
    },
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			// 获取分类
            this.getCateList()
            // 获取列表
            this.onRefresh()
            this.getUserInfo()
		}
	},
    methods: {
        toSearch() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/search/search?active=3'
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/search/search',
                    query: {
						active: 3
                    }
                })
            }
        },
        // 分类
        getCateList() {
            var params = {
                token: this.token
            }
            this.$api.dingzhi.catelist(params).then(res => {
                if (res.code == 200) {
                    var cateList = res.result
                    for (var i in cateList) {
                        cateList[i].active = 0
                    }
                    this.cateList = cateList
                }
            })
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.pages.page = 1
            this.getData();
        },
        // 定制列表
        getData() {
			var that = this
            // console.log('onRefresh状态',this.refreshing)
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            // 搜索关键字
            if (this.search_value && this.search_value != undefined && this.search_value != '') {
                params.title = this.search_value
            }
            if (this.cate_id) {
                params.custom_made_cate_id = this.cate_id
            }
            // 匠人社区
            if (this.activeType != 1) {
                // 好去处、好手艺、好体验、好食材
                for (var i in this.classifyList) {
                    if (this.classifyList[i].status) {
                        params[this.classifyList[i].name] = 1
                    }
                }
                this.$api.dingzhi.list(params).then(res => {
                    if (res.code == 200) {
						// 本周上新(实际为上周上新)
						this.typeList[0].nums = res.result.custom_made_count ? res.result.custom_made_count : 0 // 匠人社区上周
						this.typeList[1].nums = res.result.customized_community_count ? res.result.customized_community_count : 0 // 用户社区上周
						// 数据
                        if (this.pages.page == 1) {
                            this.dataList = []
						}
						// 推荐数据
						that.tuijianList = []  // 清掉原有的
						var tuijian = res.result.recommentList
						for(var j in tuijian){
							// 已定制数 = 真实定制 + 假数据
							var hadMadeCount = null
							var leftMadeCount = null
							var percentage = null
							var totalCount = tuijian[j].accept_order_count ? tuijian[j].accept_order_count : 0
							var realCount = tuijian[j].order_count ? tuijian[j].order_count : 0
							var falseCount = tuijian[j].false_data ? tuijian[j].false_data : 0
							if(parseInt(realCount) + parseInt(falseCount) <= totalCount){
								hadMadeCount = parseInt(realCount) + parseInt(falseCount)
								leftMadeCount = totalCount - realCount - falseCount
							}else{
								hadMadeCount = totalCount
								leftMadeCount = 0
							}
							if(totalCount > 0){
								percentage = Math.floor((hadMadeCount / totalCount) * 100)
							}else{
								percentage = 0
							}
							tuijian[j].leftMadeCount = leftMadeCount
							tuijian[j].hadMadeCount = hadMadeCount
							tuijian[j].percentage = percentage
							// 剩余时长 以'天'计
							if(tuijian[j].end_at){
								var endTimestamp = Date.parse(that.getTimes(tuijian[j].end_at))
								var currentTimestamp = Date.parse(new Date())
								// console.log('结束时间戳',endTimestamp)
								// console.log('当天时间戳',currentTimestamp)
								tuijian[j].timeLeft = that.$publicData.intervalTime(currentTimestamp,endTimestamp)
							}else{
								tuijian[j].timeLeft = false
							}
							that.tuijianList.push(tuijian[j])
						}
						// 全部数据
                        var list = []
                        list = res.result.list
                        if (list.length != 0) {
                            for (var i in list) {
                                var item = list[i]
                                if (item.album != "" && item.album != null) {
                                    item.images = item.album.split(",");
                                    if (item.images.length > 3) {
                                        item.images_hide = 1
                                        item.imagesSlice = item.images.slice(0, 3)
                                    }
                                }
                                that.dataList.push(item)
                                
                            }
                        } else {
                            that.refreshing = false
                            that.finished = true
                        }
                    } else {
                        that.finished = true
                        that.refreshing = false
                    }
                    for (let i = 0; i < that.dataList.length; i++) {
                        const item = that.dataList[i];
                        if(item.video_type==0 && item.other_video_url){
                            setTimeout(() => {
                                that.setPlayer(item)
                            }, 2000);
                        } else if (item.video_type==1 && item.video_url) {
                            setTimeout(() => {
                                that.setPlayer(item)
                            }, 2000);
                        }
                    }
                    that.loading = false
                    that.refreshing = false
                    that.pages.page++
                })
            } else {
                // 用户社区
                that.$api.dingzhi.comunitylist(params).then(res => {
                    if (res.code == 200) {
                        if (that.pages.page == 1) {
                            that.userDataList = []
                        }
                        var list = []
                        list = res.result.list
                        if (list.length != 0) {
                            for (var i in list) {
                                var item = list[i]
                                if (item.create_time) {
                                    item.create_time = item.created_at.split(' ')[0]
                                }
                                if (item.album) {
                                    item.images = item.album.split(",");
                                    if (item.images && item.images.length > 3) {
                                        item.images_hide = 1
                                        item.imagesSlice = item.images.slice(0, 3)
                                    }
                                }
                                // 如果用户名是手机号,隐掉中间4位
                                if (/^1[3456789]\d{9}$/.test(item.username)) {
                                    var tel = item.username
                                    item.username = tel.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
                                }
                                that.userDataList.push(item)
                            }
                        } else {
                            that.refreshing = false
                            that.finished = true
                        }
                    } else {
                        that.refreshing = false
                        that.finished = true
                    }
                    that.loading = false
                    that.refreshing = false
                    that.pages.page++
                })
            }

            // console.log('onRefresh状态+1',this.refreshing)
        },
        // 播放器
		setPlayer(item) {
			var that = this
            // var myceshi = document.getElementById('play_'+item.id);//获取元素存储在变量中
            // console.log('myceshi:',myceshi)
			// console.log('调了吗====','play_'+item.id)
			// console.log('=====',$('#'+'play_'+item.id))
            that.playStyle.display = 'block';
            var videoUrl = ''
            if(item.video_type==0 && item.other_video_url){
				videoUrl = item.other_video_url
			} else if (item.video_type==1 && item.video_url) {
                videoUrl = that.$publicData.domain + '/' + item.video_url
            }
            var instance = new Aliplayer({
                    id: 'play_'+item.id,
                    source: videoUrl,
                    width: '100%',
                    height: that.playStyle.height,
					autoplay: true, // 是否自动播放
                    isLive: false,
                    rePlay: false,
                    playsinline: true,
                    preload: true,
                    // controlBarVisibility: "hover",
                    // useH5Prism: true,
                    skinLayout: [{
                            name: "bigPlayButton",
                            align: "blabs",
                            x: 30,
                            y: 80
                        },
                        {
                            name: "H5Loading",
                            align: "cc"
                        },
                        {
                            name: "infoDisplay"
                        },
                        {
                            name: "tooltip",
                            align: "blabs",
                            x: 0,
                            y: 56
                        },
                        {
                            name: "thumbnail"
                        },
                        {
                            name: "controlBar",
                            align: "blabs",
                            x: 0,
                            y: 0,
                            "children": [
                                // {
                                //     "name": "progress",
                                //     "align": "blabs",
                                //     "x": 0,
                                //     "y": 44
                                // },
                                // {
                                //     "name": "playButton",
                                //     "align": "tl",
                                //     "x": 15,
                                //     "y": 12
                                // },
                                // {
                                //     "name": "timeDisplay",
                                //     "align": "tl",
                                //     "x": 10,
                                //     "y": 7
                                // },
                                // {
                                //     "name": "fullScreenButton",
                                //     "align": "tr",
                                //     "x": 10,
                                //     "y": 12
                                // },
                                // {
                                //     "name": "volume",
                                //     "align": "tr",
                                //     "x": 5,
                                //     "y": 10
                                // }
                            ]
                        }
                    ],
                    x5LandscapeAsFullScreen: false,
                    // x5_type:'h5',
                    showBarTime: 5000,
                    // controlBarVisibility: "always",
                    // x5_fullscreen: true,
                    x5_video_position: "bottom",
                    // "x5_orientation":"landscape",
                },
                function (player) {
                    that.player = player;
                    console.log('The player is created');
                    // $('.prism-volume').before("<i class='control_btn'></i>");
                    $("video").attr('x5-video-player-type', 'h5');
                    // $('.control_btn').on('click', function () {
                    //     if (!$('.prism-player').hasClass('fullScreen')) {
                    //         $('.prism-player').addClass('fullScreen');
                    //         $('.living_tabs').addClass('fullScreen');
                    //     } else {
                    //         $('.prism-player').removeClass('fullScreen');
                    //         $('.living_tabs').removeClass('fullScreen');
                    //     }
                    // });
                    player.mute();
                    player.play()
                    // 
                    player.on("error", function (e) {
                        console.log("error")
                        $(".prism-ErrorMessage").hide();
                        player.show_video = true;
                    })
                    player.on("ended", function (e) {
                        console.log("ended")
                        
                        player.play()
                    })
                    // player.on("ended", function (e) {
                        
                    //     player.play() = true;
                    // });
                }
            );
            that.instance = instance
            // that.instances.push(instance)
		},
        // 点击右侧图标
        clicksearchright() {
            // 没有右侧图标
            this.search_status = !this.search_status;
        },
        clickShare() {
            var that = this;
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '尊享定制',
                        detail: '尊享定制',
                        url: url,
                        platFormType: '',
                        image: that.$publicData.shareImgPath + 'dingzhi.png',
                        isMiniProgram: "1",
                        miniUserName:that.$publicData.miniUserName,
                        path: 'pages/index/index'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })
            }
        },
        // 搜索关键字
        search() {
            this.onRefresh()
        },

        // 选择分类
        clickCate(item) {
            item.active = !item.active
            for (var i in this.cateList) {
                if (this.cateList[i].id == item.id) {
                    if (item.active) {
                        this.cateList[i].active = 1
                        this.cate_id = item.id
                    } else {
                        this.cateList[i].active = 0
                        this.cate_id = null
                    }

                } else {
                    this.cateList[i].active = 0
                }
            }
            console.log('this.cateList', this.cateList)
        },
        // 重置
        reset() {
            for (var i in this.cateList) {
                this.cateList[i].active = 0
            }
            this.cate_id = null
        },
        // 确定
        submit() {
            this.search_status = false
            this.onRefresh()
        },
        // 去详情
        goDetail: function (item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var url = this.$publicData.clientUrl
                if (this.activeType != 1) {
                    url = url + '/dingzhi/detail?id=' + item.id
                } else {
                    url = url + '/dingzhi/detail/user?id=' + item.id
                }
                var params = {
                    'data': {
                        'url': url
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: this.activeType == 1 ? '/dingzhi/detail/user' : '/dingzhi/detail',
                    query: {
                        id: item.id
                    }
                })
            }
        },
        // 匠人店铺中心
        goArtDetail(item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/art/detail?tradesmanId=' + item.tradesman.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/art/detail',
                    query: {
                        tradesmanId: item.tradesman.id
                    }
                })
            }
        },
        // 关注匠人 对App和H5做判断
        attentionTadesmanClick(item) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                //获取用户信息
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            this.attentionTadesman(item);
                        }
                    }
                );
            } else {
                // console.log('对App和H5做判断')
                this.attentionTadesman(item);
            }
        },
        // 关注匠人
        attentionTadesman(item) {
            var params = {
                token: this.token,
                tradesman_id: item.tradesman.id,
                type: item.is_attention ? 2 : 1
            }
            console.log(params)
            this.$api.tradesman.attention(params).then(res => {
                if (res.code == 200) {
					this.$toast(res.message)
					// 查匠人
					this.$api.tradesman.detail({token: this.token,tradesman_id: item.tradesman.id}).then(res=>{
						if(res.code == 200){
							item.is_attention = res.result.is_attention
							that.$set(this.dataList,index,item)
						}
					})
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 展开大图 
        zhanshitupian(item, arr, index, id) {
			let xinArr = [];
			for(let j in arr){
				if(!this.$publicData.withHttpStart(arr[j])){
					xinArr.push(this.imageUrl+arr[j])
				}else{
					xinArr.push(arr[j])
				}
			};
            if (index == 2 && item.images_hide) {
                for (var i in this.dataList) {
                    if (this.dataList[i].id == item.id) {
                        this.dataList[i].images_hide = 0
                        return
                    }
                }
                return
            }
            this.bigTuImgArr = xinArr;
            this.bigTuIndex = index;
            this.bigTuShow = true;
        },
        // 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
        },
        // 发布定制
        toSheQu() {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                //获取用户信息
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            that.token = data.result.token;
                            var params = {
                                'data': {
                                    'url': that.$publicData.clientUrl + '/dingzhi/shequ'
                                }
                            }
                            that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    }
                );
            } else {
                this.goNext = true
                this.$router.push({
                    path: '/dingzhi/shequ'
                })
            }

        },
        // 发布我要定制
        toDingzhiForm() {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                //获取用户信息
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            that.token = data.result.token;
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + '/dingzhi/form'
                                }
                            }
                            that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    }
                );
            } else {
                if (!this.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.goNext = true
                    this.$router.push({
                        path: '/login'
                    })
                    return
                }
                this.goNext = true
                this.$router.push({
                    path: '/dingzhi/form'
                })
            }
        },
        // 发布定制
        toDingzhiPublish() {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                //获取用户信息
                var memberParams = {
                    data: {},
                };
                var url = ''
                if (that.is_tradesman && that.activeType != 1) {
                    url = this.$publicData.clientUrl + '/dingzhi/publish?is_tradesman=' + 1
                } else {
                    url = this.$publicData.clientUrl + '/dingzhi/publish?is_tradesman=' + 0
                }
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            that.token = data.result.token;
                            var params = {
                                'data': {
                                    'url': url
                                }
                            }
                            that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    }
                );
            } else {
                if (!this.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.goNext = true
                    this.$router.push({
                        path: '/login'
                    })
                    return
                }
                this.goNext = true
                this.$router.push({
                    path: '/dingzhi/publish',
                    query: {
                        is_tradesman: this.is_tradesman && this.activeType != 1 ? 1 : 0 // 匠人1, 普通用户0
                    }
                })
            }
        },
        // 获取用户信息，是否为匠人
        getUserInfo() {
            if (!this.token) {
                return
            }
            var params = {
                token: this.token,
                is_cloud: 0 // 0商城1云订单 ,在这里无所谓用哪个值, 为了获取用户是否为匠人角色
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    this.is_tradesman = res.result.info.userrole.is_tradesman
                }
            })
        },
        // 收藏
        clickCollect(index,item) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                //获取用户信息
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token
                        this.collect(index,item)
                    }
                })

            } else {
                this.collect(index,item)
            }
        },
        collect(index,item) {
			var that = this
			if (this.likeLoading) {
                return
            }
            var is_attention = item.is_attention
            var params = {
                token: this.token,
                custom_made_id: item.id
            }
            this.likeLoading = true
            this.$api.dingzhi.attention(params).then(res => {
                this.likeLoading = false
                if (res.code == 200) {
                    for (var i in this.dataList) {
                        if (this.dataList[i].id == item.id) {
							this.$toast(res.message)
							that.$api.dingzhi.detail({id:item.id,token: this.token}).then(res=>{
								if(res.code == 200){
									item.attention_num = res.result.attention_num
									item.is_attentioncustomized = res.result.is_attentioncustomized
									that.$set(this.dataList,index,item)
								}
							})
                            return
                        }
                    }
                }
            })
        },
        // 点赞
        clickLike(index,item) {
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                //获取用户信息
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token
                        this.like(index,item)
                    }
                })

            } else {
                this.like(index,item)
            }
        },
        like(index,item) {
			var that = this
            var is_click = item.is_click
            var params = {
                token: this.token,
                custom_made_id: item.id
            }
            if (this.likeLoading) {
                return
            }
            this.likeLoading = true
            this.$api.dingzhi.like(params).then(res => {
                this.likeLoading = false
                if (res.code == 200) {
                    for (var i in this.dataList) {
                        if (this.dataList[i].id == item.id) {
							this.$toast(res.message);
							that.$api.dingzhi.detail({id:item.id,token: this.token}).then(res=>{
								if(res.code == 200){
									item.click_num = res.result.click_num
									item.is_click = res.result.is_click
									that.$set(this.dataList,index,item)
								}
							})
                            return


							
                            // if (is_click == 0) {
                            //     this.dataList[i].is_click = 1
                            //     this.dataList[i].click_num = parseInt(this.dataList[i].click_num) + 1
                            //     this.$toast('点赞成功');
                            // } else if (is_click != 0) {
                            //     // 没有取消点赞
                            //     this.dataList[i].is_click = 0
                            //     this.dataList[i].click_num = parseInt(this.dataList[i].click_num) - 1
                            //     this.$toast('取消点赞成功');
                            // }
                            return
                        }
                    }
                }
            })
        },
        // 点击 好去处、好手艺、好体验、好食材
        clickclassify(item) {
            var that = this
            for (var i in that.classifyList) {
                var classify = that.classifyList[i]
                if (classify.name == item.name) {
                    classify.status = !classify.status
                } else {
                    classify.status = false
                }
            }
            that.pages.page = 1
            that.getData()
        },
        // 推荐
        getTuijian() {
			console.log('tuijian')
            var that = this
            var params = {
                token: that.token,
                page: 1,
                size: 1000
            }
            // 搜索关键字
            if (that.search_value && that.search_value != undefined && that.search_value != '') {
                params.title = that.search_value
            }
            if (that.cate_id) {
                params.custom_made_cate_id = that.cate_id
            }
            // 好去处、好手艺、好体验、好食材
            for (var i in that.classifyList) {
                if (that.classifyList[i].status) {
                    params[that.classifyList[i].name] = 1
                }
            }
            that.$api.dingzhi.list(params).then(res => {
                if (res.code == 200) {
                    var list = []
                    list = res.result
                    for (var i in list) {
                        if (list[i].is_recommend == 1) {
							console.log('推荐')
							// 已定制数 = 真实定制 + 假数据
							var hadMadeCount = null
							var leftMadeCount = null
							var percentage = null
							var totalCount = list[i].accept_order_count ? list[i].accept_order_count : 0
							var realCount = list[i].order_count ? list[i].order_count : 0
							var falseCount = list[i].false_data ? list[i].false_data : 0
							if(parseInt(realCount) + parseInt(falseCount) <= totalCount){
								hadMadeCount = parseInt(realCount) + parseInt(falseCount)
								leftMadeCount = totalCount - realCount - falseCount
							}else{
								hadMadeCount = totalCount
								leftMadeCount = 0
							}
							if(totalCount > 0){
								percentage = ((hadMadeCount / totalCount) * 100).toFixed(2)
							}else{
								percentage = 0
							};
							list[i].leftMadeCount = leftMadeCount
							list[i].hadMadeCount = hadMadeCount
							list[i].percentage = percentage;
							// 剩余时长 以'天'计
							if(list[i].end_at){
								var endTimestamp = Date.parse(that.getTimes(list[i].end_at))
								var currentTimestamp = Date.parse(new Date())
								console.log('结束时间戳',endTimestamp)
								console.log('当天时间戳',currentTimestamp)
								list[i].timeLeft = that.$publicData.intervalTime(currentTimestamp,endTimestamp)
							}else{
								list[i].timeLeft = false
							}




							// list[i].order_count = list[i].order_count ? list[i].order_count.toString() : '0'
							// if(list[i].accept_order_count && list[i].accept_order_count!= 0){
							// 	list[i].percentage = (list[i].order_count / list[i].accept_order_count) * 100
							// 	console.log('=====',list[i].percentage)
							// }else{
							// 	list[i].percentage = 0
							// }
                            that.tuijianList.push(list[i])
                        }
                    }
                }
            })
        },
        // 切换分类  匠人、用户社区
        changeType(item) {
            var that = this
            if (item.status) {
                return
            } else {
                for (var i in that.typeList) {
                    if (that.typeList[i].id == item.id) {
                        that.typeList[i].status = !that.typeList[i].status
                        that.activeType = that.typeList[i].id
                    } else {
                        that.typeList[i].status = false
                    }
                }
            }
            // 初始化分类
            for (var i in that.cateList) {
                that.cateList[i].active = 0
            }
            for (var i in that.classifyList) {
                that.classifyList[i].status = false
            }
            // 清空列表数据
            that.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            that.loading = true;
            that.pages.page = 1
            that.dataList = []
            that.getData();
		},
		// 兼容ios的 new Date传参, 获取时间戳; str 格式 '2020-07-15'
		getTimes(strdate){
			var arr = strdate.split(/[- : \/]/);
			var date = new Date(arr[0], arr[1] - 1, arr[2],24,0,0);
			return date;
		},
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
